module.exports = __webpack_public_path__ + "static/media/18-2.fc5ffd31.mp3";